import { createApp } from 'vue';
import App from './App.vue';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import store from './store';
import router from './router';

// Кладёт window.Pusher и инициализирует Echo как singleton при первом
// импорте. Делаем это здесь, чтобы pusher-js был доступен в Vue DevTools
// (вкладка Network → WS) и до того, как любой компонент сделает getEcho().
import '@/utils/echo';
// Глобальный fetch-interceptor для 401: после `reset-password` в админке
// у пользователя revoked-ятся все oauth_access_tokens. Любой следующий
// `fetch()` (даже прямой из компонента) теперь сам выкинет на /login
// через handleUnauthorized(). Heartbeat дополнительно гарантирует, что
// «спящая» вкладка тоже выйдет в течение ~15 сек.
import { installFetchInterceptor, startAuthHeartbeat } from '@/utils/authSession';
installFetchInterceptor();
startAuthHeartbeat();

const vuetify = createVuetify({
    components,
    directives,
});

createApp(App)
    .use(vuetify)
    .use(store)
    .use(router)
    .mount('#app');
